import { TitleSkeleton, RectangleSkeleton } from '@treezor/design-system';

export const WalletSkeleton = () => {
  return (
    <div className="flex flex-col gap-3">
      {new Array(5).fill(undefined).map((_, index) => (
        <div key={`wallet-skeleton-${index}`} className="pr-3 rounded-400 bg-primary border-2 p-5 border-primary">
          <div className="flex flex-col gap-3">
            <RectangleSkeleton width={90} height={32} margin="0" />
            <RectangleSkeleton width={150} height={25} margin="0" />
            <RectangleSkeleton width={60} height={12} margin="0" />
            <TitleSkeleton width={180} margin="1rem 0 0 0" />
            <TitleSkeleton width={180} margin="0" />
            <div className="flex items-center justify-between mt-2">
              <TitleSkeleton width={240} margin="0" />
              <RectangleSkeleton width={20} height={20} margin="0" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default WalletSkeleton;
